export default {
  Static: 1,
  Dynamic: 2,
  Voucher: 3
};
